import CuroMainLayout from 'layout/CuroMainLayout';

import DMBranchOffer from './DMBranchOffer';

const MailOfferNextSteps = () => (
  <CuroMainLayout>
    <DMBranchOffer />
  </CuroMainLayout>
);

export default MailOfferNextSteps;
